import { Suspense } from 'react'
import { createBrowserRouter } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { useTranslation } from 'react-i18next'
import { AppProviders } from './providers/AppProviders'
import { routes } from './router/routes'

/**
 * Роутер браузера — один на приложение. `RouterProvider` берётся из `react-router/dom`: только
 * он умеет `navigate(…, { flushSync: true })`, которым выход и выбор компании применяют переход
 * тем же рендером, что и сброс кеша.
 */
const router = createBrowserRouter(routes)

function AppFallback() {
  const { t } = useTranslation()
  return <p aria-live="polite">{t('app.loading')}</p>
}

export function App() {
  return (
    <AppProviders>
      <Suspense fallback={<AppFallback />}>
        <RouterProvider router={router} />
      </Suspense>
    </AppProviders>
  )
}
